import { get, post } from '../actions/method';
import noti from '../actions/toast';
import helper from '../utils/helper';
import moment from 'moment';

export const getGroups = async () => {
  return await get('app/lookup/groups?MaxResultCount=1000');
};

export async function getDepartments() {
  return await get(`app/lookup/departments?MaxResultCount=1000`);
}

export async function getDepartmentsWithoutGlobal() {
  return await get(
    `app/lookup/departments/without-global-department?MaxResultCount=1000`,
  );
}

export default { getGroups, getDepartments };
